import { MapPin, Phone, Clock } from "@phosphor-icons/react";
import { Separator } from "@/components/ui/separator";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[hsl(222,47%,11%)] text-stone-300 noise-overlay">
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Brand */}
            <div>
              <h3 className="font-heading font-extrabold text-xl text-white tracking-tight mb-4">
                Protech Mobile Mechanic
              </h3>
              <p className="text-sm leading-relaxed text-stone-400 max-w-xs">
                Veteran-owned and operated. Master-level repair, honest diagnostics, and professional execution since day one.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Quick Links
              </h4>
              <nav className="flex flex-col gap-3">
                {[
                  { label: "Home", href: "#hero" },
                  { label: "Why Us", href: "#why-us" },
                  { label: "About", href: "#about" },
                  { label: "Services", href: "#services" },
                  { label: "Reviews", href: "#reviews" },
                  { label: "Contact", href: "#contact" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <p className="text-sm text-stone-400">
                    2056 NE Aloclek Dr Ste 310,
                    <br />
                    Hillsboro, OR 97124
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Phone weight="duotone" className="w-4 h-4 text-primary shrink-0" />
                  <a
                    href="tel:+15033805413"
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                    data-testid="footer-phone-link"
                  >
                    (503) 380-5413
                  </a>
                </div>
                <div className="flex items-start gap-3">
                  <Clock weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <div className="text-sm text-stone-400">
                    <p>Mon – Sat: 10:00 AM – 6:00 PM</p>
                    <p>Sun: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-stone-800" />

        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">
            &copy; {currentYear} Protech Mobile Mechanic LLC. All rights reserved.
          </p>
          <p className="text-xs text-stone-500">
            Veteran-Owned & Operated | Professional Mobile & Shop Service
          </p>
        </div>
      </div>
    </footer>
  );
}
